(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"));
	else if(typeof define === 'function' && define.amd)
		define("graphDiagram", ["d3"], factory);
	else if(typeof exports === 'object')
		exports["graphDiagram"] = factory(require("d3"));
	else
		root["graphDiagram"] = factory(root["d3"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_d3__) {
return 